import { ConnectionStatus } from 'app/constants/connectionStatus'

export const getConnectionStatus = (statusText: string): ConnectionStatus => {
  let status: ConnectionStatus = ConnectionStatus.UNKNOWN

  if (statusText != null) {
    switch (statusText.toUpperCase()) {
      case 'SUCCESS':
        status = ConnectionStatus.CONNECTED
        break
      case 'PROCESSING':
        status = ConnectionStatus.PROCESSING
        break
      case 'CREATING':
        status = ConnectionStatus.CREATING
        break
      case 'ERROR':
        status = ConnectionStatus.NOT_CONNECTED
        break
    }
  }

  return status
}
